module.exports = __webpack_public_path__ + "img/img22.9304eb13.png";